import { IPointOfSale } from '../../../services/stock/models/stockItems.service.model';
import { getLanguageLongString } from '@utils/getLanguageLongString';
import i18next from 'i18next';
import { IDealer } from '../../../interfaces/Dealer';

const getDealerNameAndCity = (pointOfSale: IDealer | undefined): { dealerName: string; dealerCity: string } => {
    if (!pointOfSale) {
        return { dealerName: '', dealerCity: '' };
    }

    const longLangLabel = getLanguageLongString(i18next.language);

    const localizedValueOfName = Object.entries(pointOfSale.name).find(([lang]) => lang === longLangLabel)?.[1];
    const fallbackValueOfName = Object.values(pointOfSale.name)[0];

    const localizedValueOfCity = (Object.entries(pointOfSale.address).find(([lang]) => lang === longLangLabel)?.[1])?.city;
    const fallbackValueOfCity = (Object.values(pointOfSale.address)[0]).city;

    return {
        dealerName: localizedValueOfName ?? fallbackValueOfName,
        dealerCity: localizedValueOfCity ?? fallbackValueOfCity,
    };
};

export default getDealerNameAndCity;
